import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { getCatalog } from '~/entities/catalog/api';
import { withGlobalSearch } from '~/entities/catalog/url-search';
import { CompatibilityPage } from '~/pages/compatibility';

const searchSchema = withGlobalSearch({
  q: z.string().optional(),
  panel: z.string().optional(),
  connection: z.string().optional(),
  system: z.string().optional(),
  sort: z.string().optional(),
});

export const Route = createFileRoute('/compatibility')({
  validateSearch: searchSchema,
  loader: async () => getCatalog(),
  component: CompatibilityRoute,
});

function CompatibilityRoute() {
  const { q, search, panel, connection, system, sort } = Route.useSearch();

  // `?search=` is the pre-`?q=` form older "Check compatibility" links used; still honoured.
  return <CompatibilityPage q={q ?? search} panel={panel} connection={connection} system={system} sort={sort} />;
}
